import * as m from 'mithril';
import './MaterialDesignComponents.scss';
import CustomSvgIcon, { CustomSvgIconType } from './CustomSvgIcon';

interface ActionItemDescriptor {
    iconType?: CustomSvgIconType,
    label?: string|null,   
    onclick: () => void;
}


function Button() : m.Component<{onClick?: () => void}> {
    return {
        view(vnode) {
            return m("button", {
                class:"btn btn-success mmd-ripple shadow-sm",
                onclick: (event:any) => {
                    if(vnode.attrs.onClick != null) {
                        vnode.attrs.onClick();
                    }
                }
            }, vnode.children)
        }
    }
}

function Card() : m.Component<{}> {
    return {
        view(vnode) {
            return m("div", {class:"card mmd-ripple mmd-ripple-dark", href:"#", onclick: (e)=> {}  }, 
                m("div.card-body", vnode.children)
            )
        }
    }
}

interface SelectionItem {
    label?: string|null,
    onSelected: () => void;
}

function Dialog(): m.Component<{
    title? : string,    
    message? : string,
    iconType?: CustomSvgIconType,
    iconThemeClass?: string,
    isOpen: boolean,
    onClose: () => void,
    actionItems?: ActionItemDescriptor[],
    selectionItems?: SelectionItem[]
}> {
    let domElem:Element|null = null;
        
    return {        
        oncreate(vnode) {
            domElem = vnode.dom;
        },

        view(vnode) {
            let attrs = vnode.attrs;
            
            return m("div", {
                class: attrs.isOpen? "mmd-modal mmd-modal-shown" : "mmd-modal mmd-modal-hidden",
                onclick: (event) => {                     
                    if(event.target == domElem) {
                        attrs.onClose();
                    }
                }
            },
                (attrs.isOpen)?
                m("div.card", {
                    class: 'mr-4 mmd-modal-content shadow-lg',
                    onclick: (event) => {},
                },
                    [
                        m("div.card-header",{class:"pb-2 bg-white border-0"}, [       

                            (vnode.attrs.iconType != null)? 
                            m("span.mr-2", 
                                m(CustomSvgIcon,{
                                    iconType: vnode.attrs.iconType,
                                    themeCssClass: vnode.attrs.iconThemeClass? vnode.attrs.iconThemeClass : "svg-medium svg-warning"
                                })
                            ):null,

                            (vnode.attrs.title != null)? 
                            m("span.lead", {class:"font-weight-bold mb-3"}, vnode.attrs.title) : null,

                        ]),
                        m("div.card-body.pt-0", [       
                            (vnode.attrs.message != null)?
                            m("div", {class:"mb-1"}, vnode.attrs.message): null,
                            
                            vnode.children,

                            (vnode.attrs.selectionItems!=null)?
                            m("div", {class: "list-group list-group-flush"}, 
                                vnode.attrs.selectionItems.map(item => {
                                    return m("div",
                                        {
                                            class : "list-group-item mmd-ripple mmd-ripple-dark",
                                            onclick: (event) => {
                                                item.onSelected();
                                            }
                                        }, 
                                        item.label);
                                })
                            ) : null,
                        ]), 
                            (vnode.attrs.actionItems != null)? 
                            m("div.card-footer", {class: "text-right border-0 bg-white pt-0"},
                                vnode.attrs.actionItems.map(item => {
                                    return m("button", {
                                        class:'btn btn-light text-primary mr-1',
                                        onclick: function(event) {
                                            item.onclick();
                                            //attrs.onClose();
                                        }
                                    }, item.label)
                                })                        
                            ): null
                        
                    ]
                ) : null
            )
        }
    };
}

export {Card, Button, Dialog, ActionItemDescriptor}


